import {
  createCurrencyStrategy,
  type DynamicComponent,
  type StrategyFactoryOptions
} from '@dec/shared';
import { useGetGlobalTaxReturnValues } from 'app/modules/FormDefinition/services/signalr.hooks';
import i18next from 'i18next';

import { ChangeComponent } from '../../../ChangeComponent';

const options: StrategyFactoryOptions = {
  ChangeComponent,
  getRequiredMessage: () => i18next.t('common.validations.fieldRequired'),
  useRuntime: useGetGlobalTaxReturnValues
};

export default createCurrencyStrategy(options) as DynamicComponent;
